import { Controller } from "react-hook-form";
import { BaseField } from "./BaseField";
import { FieldProps } from "modules/record/record-producer/types/record-producer-types";
import { DateFieldInput } from "modules/record/shared/fields/DateFieldInput";
import { buildRequiredRule, getRequiredFieldMessage } from "../../services/recordProducerValidation";
import { getFieldHelperText } from "../../services/fieldHelperText";

export const DateFieldComponent = ({ column, control, baseFieldProps, runtimeProps }: FieldProps) => {
    return (
        <BaseField column={column} required={runtimeProps?.required} hidden={runtimeProps?.hidden} {...baseFieldProps}>
            <Controller
                name={column.name}
                control={control}
                defaultValue={column.default_value && column.default_value !== "" ? column.default_value : undefined}
                rules={{ required: buildRequiredRule(runtimeProps?.required ?? column.is_mandatory, getRequiredFieldMessage(column)) }}
                render={({ field, fieldState }) => (
                    <DateFieldInput
                        value={field.value ?? null}
                        onChange={field.onChange}
                        disabled={runtimeProps?.readonly}
                        error={!!fieldState.error}
                        helperText={getFieldHelperText(fieldState, runtimeProps)}
                    />
                )}
            />
        </BaseField>
    );
};
